import { Reveal } from "../lib/motion";
import { PROCESS } from "../data";

export const Process = () => (
  <section id="process" className="relative border-t border-black/10 py-28 md:py-36" data-testid="process-section">
    <div className="container-vx">
      <div className="mb-16 max-w-2xl md:mb-24">
        <Reveal>
          <span className="label-mono">/ The method</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-sans text-4xl font-light leading-tight tracking-tight md:text-5xl">
            Four chapters from friction to fully autonomous.
          </h2>
        </Reveal>
      </div>

      <div className="flex flex-col">
        {PROCESS.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.05}>
            <div
              className="group grid grid-cols-1 items-start gap-6 border-t border-black/10 py-10 transition-colors duration-500 hover:bg-black/[0.02] md:grid-cols-12 md:gap-10 md:py-14"
              data-testid={`process-step-${i}`}
            >
              <div className="md:col-span-2">
                <span className="font-mono text-4xl font-light text-neutral-300 transition-colors duration-500 group-hover:text-[var(--accent)] md:text-5xl">
                  {p.n}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-sans text-3xl font-medium tracking-tight transition-transform duration-500 group-hover:translate-x-1 md:text-4xl">
                  {p.title}
                </h3>
              </div>
              <div className="md:col-span-6">
                <p className="max-w-xl font-body text-lg leading-relaxed text-neutral-600">
                  {p.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-black/10" />
      </div>
    </div>
  </section>
);
